module.exports = __webpack_public_path__ + "static/img/3.bbb24de.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/1/eng/3.png
// module id = L1R5
// module chunks = 0